import {
    customEventTarget,
    handleCustomEvent,
} from './auth-events/authCallback'

async function logout(app) {
    try {
        app.currentUser && (await app.currentUser.refreshCustomData())

        app.currentUser && (await app.currentUser.logOut())

        !app.currentUser &&
            customEventTarget.addEventListener('logout', handleCustomEvent)
        !app.currentUser &&
            customEventTarget.dispatchEvent(
                new CustomEvent('logout', { detail: { app } })
            )

        return {
            newAppInstance: app,
        }
    } catch (error) {
        console.error(error)
        return null
    }
}

export default logout
